import { mapGetters } from 'vuex'
// import help from '../../../../utils/help'
import help from '@/utils/help'
import manuscript from '@/api/manuscript'
import article from '@/api/article'
import { openAuthor } from '@/api/open'

import { DECISION_STATUS } from '@/utils/dict'
import { getUploadConfig } from '@/utils/upload'
// import Loading from '../upload-documents/loading.dialog'
import Loading from '../../author/submit-manuscripts/upload-documents/loading.dialog'
import axios from 'axios'
export default {
  components: { Loading },
  data() {
    return {
      // 取回数据
      reviewsResponse: {
        status: '2' // 同意审稿状态 首次 0 / 收起 1 / 复审 2
      },
      showFunding: true,
      showEditor: true,
      showReviewer: true,
      showResubmit: true,
      showCommment: true,
      // 填写数据
      params: {
        authorReplyMacademic: {
          // macademicId: '',
          authorReply: '',
          authorReplyFileList: []
        },
        authorReplyMeditor: {
          meditorId: '',
          authorReply: ''
        }
      },
      //基金
      founds: [],
      foundation: {
        name: '',
        code: ''
      },
      foundationList: [],
      rules: {},
      reviewerFileList: [],
      termList: DECISION_STATUS,
      isMoreText: false,
      getFound: '',
      // 文件
      fileTypes: {},
      ftype: [],
      hasUploadFiles: [],
      disableStatu: false,
      uploadProgress: {
        current1: 0,
        current2: 0,
        current3: 0,
        current4: 0,
        current5: 0,
        current6: 0,
        current7: 0,
        current8: 0,
        current9: 0
      },

      loading: false,
      uploadingAttachments: false,
      submitting: false,
      downloadAttachment: [],
      hasFoun: false,
      source: null
    }
  },
  async mounted() {
    this.getRules()
    await this.getData()
    this.getFound()
    // await this.getTypes()

    // this.getSection()
    // this.getJournalList()
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      manuscript: 'getManuscript',
      domain: 'getDomain'
    })
    // termList() {
    //   return Object.values(this.articalStatus)
    // }
  },
  methods: {
    getRules() {
      this.rules = {
        quality: [
          {
            required: true,
            message: this.LANGUAGE[this.language].noEmpty
          }
        ],
        suggestion: [
          {
            required: true,
            message: this.LANGUAGE[this.language].noEmpty
          }
        ]
      }
    },

    // 获取数据
    async getData() {
      let routeName = this.$route.name
      switch (routeName) {
        // case '/author/submitted-manuscripts/author-report':
        //   this.disableStatu = false
        //   break
        case '/email-url/author-revise':
          this.disableStatu = true
          break
        default:
          this.disableStatu = true
      }

      let id = this.$route.query.id || this.$route.query.manuscriptId
      let data = {
        sign: this.$route.query.sign
      }
      // const result = await manuscript.query(id, data)
      const result = await openAuthor.authorMascript(id, data)
      if (
        !['PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS'].includes(
          result.status
        )
      ) {
        this.$router.push(`/email-url/invalid-page?id=${id}&sign=${data.sign}`)
        return
      }
      this.getFound = help.debounce(async () => {
        this.founds = await article.getFound(this.foundation.name)
      }, 1000)
      if (result.id) {
        let disTotal = 0
        if (result.discountDetailList && result.discountDetailList.length > 0) {
          result.discountDetailList.forEach(ele => {
            disTotal += ele['discount']
          })
          result.__diacountTotal = disTotal
        }
        const { foundationList, fileList } = result
        this.foundationList = foundationList
          ? JSON.parse(JSON.stringify(foundationList))
          : []
        this.flag = true
        if (foundationList && foundationList.length) {
          this.hasFoun = true
        }
        this.$set(this.params, 'foundationList', foundationList || [])
        this.$set(this.params, 'fileList', fileList || [])

        this.reviewsResponse = result
        this.params.foundationList = result.foundationList || []
        this.downloadAttachment =
          this.reviewsResponse &&
          this.reviewsResponse.decisionType &&
          this.reviewsResponse.decisionType === 'FINAL_DECISION'
            ? this.reviewsResponse.inviteReviewerFileList
            : this.reviewsResponse.inviteMacademicFileList
      }
      await this.getTypes()
    },

    onChange() {},
    // 基金
    onHasFunChange() {
      this.hasFoun = !this.hasFoun
      this.foundation = {
        name: '',
        code: ''
      }
      if (!this.hasFoun) {
        this.params.foundationList = []
      } else {
        this.params.foundationList = this.foundationList
          ? JSON.parse(JSON.stringify(this.foundationList))
          : []
      }
    },
    onFoundationChange() {
      // this.foundation.code = val.code
    },
    async AddFoun() {
      if (!this.foundation.name && this.foundation.code) {
        this.$message.error({
          title: 'Error',
          content: 'Funding name' + this.LANGUAGE[this.language].noEmpty
        })
        return
      }
      // if (this.foundation.name && !this.foundation.code) {
      //   this.$message.error({
      //     title: 'Error',
      //     content: 'Funding number' + this.LANGUAGE[this.language].noEmpty
      //   })
      //   return
      // }
      this.getFound()
      if (this.foundation.name) {
        const flag = this.params.foundationList.some(item => {
          if (item.code && item.code === this.foundation.code) {
            return true
          }
        })
        if (flag) {
          this.foundation = {
            name: '',
            code: ''
          }
          return
        }
        this.params.foundationList.push(this.foundation)
        this.foundation = {
          name: '',
          code: ''
        }
      }
      if (!this.foundation.name && !this.foundation.code) {
        return
      }
    },
    delFoun(index) {
      this.params.foundationList.splice(index, 1)
    },

    async handleUpload(fileType, files) {
      const types = fileType.typeFile.split('; ')
      const file = files[0]
      let type = file.name.split('.')
      type = type[type.length - 1].toLowerCase()
      this.source = axios.CancelToken.source()
      if (!types.includes(type)) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      } else {
        this.addFile(fileType, file)
      }
    },

    addFile(fileType, file) {
      const MS = 200
      let rest = MS * 1024 * 1024

      for (let item in this.fileTypes) {
        if (item.file && item.id !== fileType.id) {
          rest -= item.file.size
        }
      }

      const data = {
        name: file.name,
        size: file.size,
        itemCode: fileType.id,
        description: '',
        path: '',
        file: file,
        lastTime: this.$moment()
      }

      let flag = false
      if (rest - file.size < 0) {
        flag = true
      } else {
        this.fileTypes[fileType.id].file = data
      }

      if (flag) {
        this.$message.error({
          title: 'Error',
          content:
            'Files can only be uploaded up to 200M, please compress and upload again'
        })
      }
    },

    async handleUpload1(files) {
      const types = [
        'pdf',
        'docx',
        'doc',
        'txt',
        'png',
        'jpg',
        'jpeg',
        'mp4',
        'mp3',
        'html',
        'xml',
        'mov',
        'xls',
        'xlsx',
        'zip',
        'tif',
        'tiff',
        'rtf'
      ]
      const validFiles = []
      for (const file of files) {
        let type = file.name.split('.')
        type = type[type.length - 1].toLowerCase()
        if (!types.includes(type)) {
          this.$message.error({
            title: 'Error',
            content: this.LANGUAGE[this.language].isWrongType
          })
        } else {
          validFiles.push(file)
        }
      }
      if (validFiles.length) {
        await this.addFile1(validFiles)
      }
    },
    async addFile1(files) {
      const fileList = Array.isArray(files) ? files : [files]
      const replyFileList = this.params.authorReplyMacademic.authorReplyFileList

      fileList.forEach(file => {
        const fileData = {
          name: file.name,
          size: file.size,
          sort: '',
          description: '',
          path: '',
          file: file,
          lastTime: this.$moment()
        }
        const index = replyFileList.findIndex(item => item.name === file.name)
        if (index === -1) {
          replyFileList.push(fileData)
        } else {
          this.$set(replyFileList, index, fileData)
        }
      })

      const manuscriptId = this.getManuscriptId()
      if (!manuscriptId) {
        this.$message.error({
          title: 'Error',
          content: 'The manuscript ID is missing. Please refresh the page and try again.'
        })
        return
      }

      const path = `publisher/${this.publisherId}/manuscript/${manuscriptId}/submit/${help.guid()}`
      const proAll = []
      this.uploadingAttachments = true
      this.source = this.source || axios.CancelToken.source()
      this.uploadProgress = {
        current: 0,
        total: replyFileList.length
      }

      replyFileList.forEach((item, index) => {
        item.sort = item.sort === '' ? index : item.sort
        if (!item.path) {
          proAll[index] = getUploadConfig(
            item.file,
            path,
            '',
            this.source.token,
            () => {}
          ).then(res => {
            if (res && !res.includes('err:')) {
              this.uploadProgress.current++
            }
            return res
          })
        } else {
          this.uploadProgress.current++
        }
      })

      try {
        const reses = await Promise.all(proAll)
        this.errArr = []
        reses.forEach(item => {
          if (item && item.includes('err:')) {
            this.errArr.push(item.split(':')[1])
          }
        })

        replyFileList.forEach((item, index) => {
          if (!item.path && reses[index] && !reses[index].includes('err:')) {
            item.path = reses[index]
          }
          item.sort = index
        })

        if (this.errArr.length || replyFileList.some(item => !item.path)) {
          this.$message.error(this.LANGUAGE[this.language].uploadFileFail, 5)
        }
      } catch (error) {
        this.$message.error(this.LANGUAGE[this.language].uploadFileFail, 5)
      } finally {
        this.uploadingAttachments = false
      }
    },

    delFile(index) {
      this.params.authorReplyMacademic.authorReplyFileList.splice(index, 1)
    },

    async download(file) {
      const url = file.path
        ? this.domain + '/' + file.path
        : window.URL.createObjectURL(file.file)
      help.download(url, file.name)
    },

    del(item) {
      this.$confirm({
        title: 'Are you sure you want to delete this file?',
        content:
          'Please be aware of once this file is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        this.fileTypes[item.id].file = ''
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
      })
    },

    // 文件类型
    async getTypes() {
      const fileTypes = {}
      const types = await manuscript.ftype()
      types.forEach(item => {
        item.file = ''
        fileTypes[item.id] = item
      })
      this.ftype = types
      this.fileTypes = fileTypes
    },

    // 提交
    async submit() {
      if (this.loading || this.uploadingAttachments || this.submitting) {
        return
      }
      this.submitting = true

      const ids = this.getManuscriptId()
      let datas = {
        sign: this.$route.query.sign
      }
      // const result = await manuscript.query(id, data)
      const res = await openAuthor.authorMascript(ids, datas)
      if (
        !['PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS'].includes(
          res.status
        )
      ) {
        this.$router.push(
          `/email-url/invalid-page?id=${ids}&sign=${datas.sign}`
        )
        this.submitting = false
        return
      }
      // console.log(this.reviewsResponse, 'sss')
      let flag = false

      for (let key in this.fileTypes) {
        if (this.fileTypes[key].required && !this.fileTypes[key].file) {
          flag = true
        }
      }

      if (flag) {
        this.$message.error({
          title: 'Error',
          content: `You have to upload at least 2 types of documents, including Cover letter, Manuscript.`
        })
        this.submitting = false
        return
      }

      if (
        (this.reviewsResponse.reviewReportList &&
          this.reviewsResponse.reviewReportList.length > 0) ||
        this.reviewsResponse.macademicId
      ) {
        if (
          this.reviewsResponse.decisionType != 'FINAL_DECISION' &&
          this.reviewsResponse.authorNotes
        ) {
          if (!this.params.authorReplyMacademic.authorReply) {
            this.$message.error({
              title: 'Error',
              content: `Response to Academic editor's comments cannot be empty!`
            })
            this.submitting = false
            return
          }
        }
      }

      if (
        this.reviewsResponse.authorNotes &&
        this.reviewsResponse.decisionType === 'FINAL_DECISION'
      ) {
        if (!this.params.authorReplyMeditor.authorReply.trim()) {
          this.$message.error({
            title: 'Error',
            content: `Response to Editor's comments cannot be empty!`
          })
          this.submitting = false
          return
        }
      }

      const manuscriptId = this.getManuscriptId()
      if (!manuscriptId) {
        this.$message.error({
          title: 'Error',
          content: 'The manuscript ID is missing. Please refresh the page and try again.'
        })
        this.submitting = false
        return
      }

      const path = `publisher/${this.publisherId}/manuscript/${
        manuscriptId
      }/submit/${help.guid()}`

      this.params.fileList = []

      for (let key in this.fileTypes) {
        if (this.fileTypes[key].file) {
          this.params.fileList.push(this.fileTypes[key].file)
        }
      }

      const pro_all = []
      this.loading = true
      this.source = axios.CancelToken.source()
      const allFiles = [] // 接口获取的需上传的文件列表
      const hasFiles = []

      for (let key in this.fileTypes) {
        allFiles.push(key)
        this.uploadProgress = Object.assign(this.uploadProgress)
        if (this.fileTypes[key].file) {
          hasFiles.push(this.fileTypes[key])
        }
      }

      this.hasUploadFiles = hasFiles
      hasFiles &&
        hasFiles.map((key, index) => {
          if (key.file && key.file.file && !key.file.file.path) {
            pro_all[index] = getUploadConfig(
              key.file.file,
              path,
              '',
              this.source.token,
              e => {
                this.ftype.forEach(item => {
                  if (item.typeName == key.typeName) {
                    switch (item.typeName) {
                      case 'Cover Letter':
                        this.uploadProgress.current1 = e
                        break
                      case 'Manuscript (Word/ZIP)':
                        this.uploadProgress.current2 = e
                        break
                      case 'Manuscript (PDF Version)':
                        this.uploadProgress.current3 = e
                        break
                      case 'Graphical Abstract':
                        this.uploadProgress.current4 = e
                        break
                      case 'Supplementary Material':
                        this.uploadProgress.current5 = e
                        break
                      case 'Figure(s)':
                        this.uploadProgress.current6 = e
                        break
                      case 'Table(s)':
                        this.uploadProgress.current7 = e
                        break
                      case 'Dataset(s)':
                        this.uploadProgress.current8 = e
                        break
                      case 'Video(s)':
                        this.uploadProgress.current9 = e

                        break
                      default:
                        break
                    }
                  }
                })

                // } else if (index == 1) {
                //   this.uploadProgress1.current = e
                // }
              }
            ).then(res => {
              if (res && !res.includes('err:')) {
                // this.uploadProgress.current++
              }
              return res
            })

            key.index = index
          } else {
            // this.uploadProgress.current++
          }
        })

      try {
        const reses = await Promise.all(pro_all)
        this.errArr = []
        reses.forEach(item => {
          if (item && item.includes('err:')) {
            this.errArr.push(item.split(':')[1])
          }
        })

        for (let key in this.fileTypes) {
          if (
            !this.fileTypes[key].file.path &&
            reses[this.fileTypes[key].index] &&
            !reses[this.fileTypes[key].index].includes('err:')
          ) {
            this.fileTypes[key].file.path = reses[this.fileTypes[key].index]
          }
        }

        if (this.errArr.length) {
          this.$message.error(this.LANGUAGE[this.language].uploadFileFail, 5)
          this.uploadProgress = {
            current: 0,
            total: 0
          }
          return
        }

        if (
          this.params.fileList.some(item => !item.path) ||
          this.params.authorReplyMacademic.authorReplyFileList.some(
            item => !item.path
          )
        ) {
          this.$message.error(this.LANGUAGE[this.language].uploadFileFail, 5)
          return
        }

        this.loading = false

        const { id, version, macademicId, meditorId } = this.reviewsResponse
        const data = Object.assign(this.params, {
          id,
          version
        })
        this.params.authorReplyMacademic.macademicId = macademicId
        this.params.authorReplyMeditor.meditorId = meditorId

        // await manuscript.revision(data)
        await openAuthor.authorRevise(data)
        this.$message.success({
          title: 'Success',
          content: 'Submit Successfully'
        })
      } catch (error) {
        this.$message.error(this.LANGUAGE[this.language].uploadFileFail, 5)
      } finally {
        this.loading = false
        this.submitting = false
      }
    },

    getManuscriptId() {
      return (
        (this.reviewsResponse &&
          (this.reviewsResponse.id || this.reviewsResponse.manuscriptId)) ||
        this.$route.query.id ||
        this.$route.query.manuscriptId
      )
    },

    replay(val) {
      if (this.disableStatu) {
        this.$router.push(
          // '/author/submitted-manuscripts/author-revised/replay/' + val.id
          '/email-url/author-revise/reply?id=' + val.id
        )
      } else {
        this.$router.push('/author/submitted-author/report/?id=' + val.id)
      }
    },
    cancel() {
      this.loading = false
      location.reload()
    }
  }
}
